import { useCallback } from 'react';
import { ACCEPT_PLATFORM_TERMS_KIND } from '../../../services/acceptPlatformTermsKind';
import { useAcceptPlatformTermsMutation, useCreateAccountPasswordMutation, useLoginMutation, } from '../../../services/onboardingApi';
import { useAccountData } from '../../hooks';
export function useTermsOfUse() {
    const { cpf, password } = useAccountData();
    const [createAccountPassword, { isLoading: isCreatingPassword, error: createPasswordError }] = useCreateAccountPasswordMutation();
    const [login, { isLoading: isLoggingIn, error: loginError }] = useLoginMutation();
    const [acceptPlatformTerms, { isLoading: isAcceptingTerms, error: acceptTermsError }] = useAcceptPlatformTermsMutation();
    const handleCreateAccount = useCallback(async () => {
        if (!cpf || !password) {
            return { success: false, error: 'Missing required data' };
        }
        try {
            await createAccountPassword({
                document: cpf,
                password,
            }).unwrap();
        }
        catch (err) {
            return { success: false, error: err };
        }
        let jwtToken;
        try {
            const loginResult = await login({
                documentNumber: cpf,
                password,
            }).unwrap();
            jwtToken = loginResult.result.jwtToken;
        }
        catch (err) {
            return { success: false, error: err };
        }
        try {
            await acceptPlatformTerms({
                kind: ACCEPT_PLATFORM_TERMS_KIND.ONBOARDING_JWT,
                accessToken: jwtToken,
            }).unwrap();
        }
        catch {
        }
        return { success: true };
    }, [cpf, password, acceptPlatformTerms, createAccountPassword, login]);
    return {
        handleCreateAccount,
        isLoading: isCreatingPassword || isLoggingIn || isAcceptingTerms,
        error: createPasswordError ?? loginError ?? acceptTermsError,
    };
}
